module.exports = __webpack_public_path__ + "img/check-round.005231ef.svg";